<template>
  <div>
    <a-card style="width: 100%; margin-bottom: 20px;">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="12">
            <a-col :md="5" :sm="12">
              <a-form-item label="管类选择">
                <a-select style="width: 220px" placeholder="请选择管类" @change="handleChange">
                  <a-select-option v-for="(item, index) in list" :key="index" :value="item.id">
                    {{ item.tubeClassName }} ({{ item.tubeClassCode }})
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="12" style="display: flex">
              <a-button type="primary" style="margin-left: 12px" @click="elementSetting()" >属性设置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>

    <a-card style="width: 100%; " v-show="elementSettingCard">
      <a-spin :spinning="spinning">
        <div class="titleName">
          <span>{{ titleText }}</span>
        </div>
        <div style="margin-bottom: 10px;">
          <a-row :gutter="12">
            <a-col :md="5" :sm="12" style="display: flex">
              <a-button type="primary" @click="addOrUpdateHandle()" v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()" v-action:del>删除</a-button>
            </a-col>
          </a-row>
        </div>

        <a-table ref="table" :columns="columns" :data-source="propertyList" bordered :pagination="false"
          :scroll="{ y: 510 }" :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
          :rowKey="(record, index) => record.id"
          :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)">

          <span slot="reveal" slot-scope="text, record">
            <!-- <a-switch :checked="(record.ifOpen == 0) ? true : false" @change="onRevealChangeUpdate(record)"  /> -->
             {{ record.ifOpen == 0 ? '是' : '否'}}
          </span>
          <span slot="action" slot-scope="text, record">
            <a style="margin-left: 15px;" @click="Handle(record)" v-action:edit>编辑</a>
          </span>
        </a-table>



        <a-modal :title="isUpdate ? '编辑' : '新增'" width="50%" v-model="addOrUpdateVisible" >
          <a-form :form="addOrUpdateForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
            <a-form-item label="属性名称">
              <a-input placeholder="请输入属性名称"
                v-decorator="['attributeName', { rules: [{ required: true, message: '请输入属性名称' }] }]" />
            </a-form-item>
            <a-form-item label="排序值">
              <a-input placeholder="请输入排序值"
                v-decorator="['sortValues', { rules: [{ required: true, message: '请输入排序值' }] }]" />
            </a-form-item>
            <a-form-item label="是否显示">
              <a-switch @change="onRevealChangeIfOpen" v-decorator="['ifOpen', { valuePropName: 'checked' }]" />
            </a-form-item>
          </a-form>
          <div slot="footer">
            <a-button @click="handleCancel">取消</a-button>
            <a-button type="primary" @click="handleOk" >确定</a-button>
          </div>
        </a-modal>
      </a-spin>
    </a-card>

  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { Cascader as ACascader } from 'ant-design-vue';

const columns = [
  {
    title: '排序编号',
    dataIndex: 'sortValues'
  },
  {
    title: '属性名称',
    dataIndex: 'attributeName'

  },
  {
    title: '是否显示',
    dataIndex: 'ifOpen',
    scopedSlots: { customRender: 'reveal' }
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: 200,
    scopedSlots: { customRender: 'action' }
  }
]

const list = [];
export default {
  components: {
    'a-cascader': ACascader,
  },
  mixins: [mixinViewModule],
  name: 'ElementSetting',
  data () {
    return {
      list,
      columns,
      needPage: false,
      needQuery: false, // 是否在created就执行查询操作
      spinning: false,
      queryUrl: '/gis-manager/foundation/attribute/list',
      queryListUrl: '/gis-manager/foundation/attribute/property',
      addUrl: '/gis-manager/foundation/attribute/add',
      updateUrl: '/gis-manager/foundation/attribute/edit',
      queryOneUrl: '/gis-manager/foundation/attribute/get',
      deleteUrl: '/gis-manager/foundation/attribute/remove',
      pLId: '',
      options: [],
      updataId: '',
      propertyList: [],
      ifOpen: '1',
      titleText: '',
      elementSettingCard: false,
      query: {
        ruleName: '',
        tenantId: this.$store.state.user.info.tenantId
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' })
    }
  },
  computed: {

  },
  created () {
    this.queryList()
  },
  methods: {
    resetList () {
      this.updataId = ''
      this.getElementList()
    },
    onRevealChange (item) {
      console.log(item)
    },
    onRevealChangeIfOpen (e) {
      if (e) {
        this.ifOpen = '0'
      } else {
        this.ifOpen = '1'
      }
    },
    addOrUpdateHandle (id) {
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      if (id) {
        this.isUpdate = true
        this.$http.get(`${this.queryOneUrl}/${this.currentId}`).then(({
          data
        }) => {
          this.ifOpen = data.ifOpen
          if (data.ifOpen == '0') {
            data.ifOpen = true
          } else {
            data.ifOpen = false
          }
          this.addOrUpdateForm.setFieldsValue({
            sortValues: data.sortValues,
            attributeName: data.attributeName,
            ifOpen: data.ifOpen
          })
        }).catch(() => { })
      }
    },
    handleCancel (e) {
      this.addOrUpdateVisible = false

    },
    Handle (record) {
      this.updataId = record.id
      this.addOrUpdateHandle(record.id)
      this.showModal()
    },
    showModal () {
      this.visible = true;
    },
    handleChange (value, item) {
      this.pLId = value;
      this.titleText = item.componentOptions.children[0].text;
    },
    onRevealChangeUpdate (e) {
      if (e.ifOpen == '0') {
        e.ifOpen = '1'
      } else {
        e.ifOpen = '0'
      }
      this.$http.post(this.updateUrl, e).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.message)
          this.resetList()
        } else {
          this.$message.error('修改失败')
        }
      })
    },
    elementSetting () {
      console.log(this.pLId);
      if (this.pLId == '' || this.pLId == undefined) {
        this.$message.warning('请选择一个要素进行配置')
      } else {
        this.getElementList()
      }
    },
    getElementList () {
      this.spinning = true;
      this.$http.get(this.queryListUrl + '/' + this.pLId).then(res => {
        if (res.code == 0) {
          this.elementSettingCard = true;
          this.propertyList = res.data
          //this.$message.success('查询管类属性成功')
        } else {
          this.$message.error('查询失败')
        }
      }).finally(() => {
        setTimeout(() => {
          this.spinning = false;
        }, 500);
      })
    },
    deleteSelectRow () {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }
      const _this = this
      const selectedCount = this.selectedRows.length
      const selectedIds = this.selectedRows.map(str => parseInt(str, 10))
      console.log(selectedIds)
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除选择的${selectedCount}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          _this.$http.post(_this.deleteUrl,
            selectedIds
          ).then((res) => {
            if (res.code === 0) {
              _this.$message.success(`共删除${selectedCount}条数据`)
              _this.selectedRows = []
              _this.resetList()
              _this.queryList()
            }
          }).catch(() => { })
        },
        onCancel () {
          _this.$message.info('已取消删除')
        }
      })
    },
    handleOk () {
      this.addOrUpdateForm.validateFields((err, values) => {
        let addOrUpdataUrl = this.addUrl
        if (this.updataId != '') {
          addOrUpdataUrl = this.updateUrl
          values.id = this.updataId
        }
        console.log('handleOk', this.updataId, addOrUpdataUrl);

        values.propertiesSettingId = this.pLId
        values.ifOpen = this.ifOpen
        console.log(values);
        if (!err) {
          this.$http.post(addOrUpdataUrl, values).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.message)
              this.addOrUpdateVisible = false
              this.updataId = ''
              this.resetList()
            } else {
              this.$message.error('操作失败')
            }
          })
        }
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  }
}
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  height: 99vh;
  // border: 1px solid red;
}

.titleName {
  margin-bottom: 20px;

  span {
    font-size: 16px;
    color: #333333;
    line-height: 22px;
  }

}

.search {
  width: 100%;
  height: 40px;
  // border: 1px solid red;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

/deep/.table-striped {
  background-color: #fafafa;
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>